/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Canbedownloadedasquittung4Inputs */



/**

* @param {_Field_Canbedownloadedasquittung4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_canbedownloadedasquittung4 = /** @type {((inputs?: _Field_Canbedownloadedasquittung4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Canbedownloadedasquittung4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Als Quittung herunterladbar")
});
export { _field_canbedownloadedasquittung4 as "_field_canBeDownloadedAsQuittung" }